import type { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';
import type { DataCyProp } from '@/types';
import { TypographySize } from '../enums/size';
import type { StaticOptions } from '../types/StaticOptions';

export interface CounterProps extends DataCyProp {
  size?: TypographySize.Large | TypographySize.Medium;
  /**
   * When used in static context, staticOptions must be provided to the component
   *  */
  staticOptions?: StaticOptions;
}

export const StyledCounter = styled.span<Pick<CounterProps, 'size'>>`
  margin: 0;
  color: ${({ theme }) => theme.color.semantic.type.primary};

  ${({ theme, size }) =>
    size === TypographySize.Large
      ? theme.typography.configurations.counterLarge
      : theme.typography.configurations.counterMedium};
`;

export const Counter: FC<PropsWithChildren<CounterProps>> = ({
  children,
  size = TypographySize.Medium,
  staticOptions,
  'data-cy': dataCy,
}) => {
  const { theme } = staticOptions ?? {};
  return (
    <StyledCounter data-cy={dataCy} size={size} theme={theme}>
      {children}
    </StyledCounter>
  );
};
